<div class="dialog-content-wrapper query-filter-dialog-wrapper">
  <mat-toolbar matDialogTitle class="mat-accent m-0">
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title">{{dialogTitle}}</span>
      <button mat-icon-button (click)="dialogRef.close(false)" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-16 m-12">
    <div class="search-wrapper" *ngIf="!isEditing" @inOut>
      <mat-form-field class="search-field query-filter-edit-search-field" appearance="outline" floatLabel="always">
        <mat-label>Search filters</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <input autocomplete="off" matInput type="text" [(ngModel)]="searchValue" (ngModelChange)="searchUpdated()" [disabled]="!!isEditing">
        <button *ngIf="searchValue" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="content-wrapper" [class.disabled]="!showList">

      <cdk-virtual-scroll-viewport #scroller itemSize="56" class="content" [class.disabled]="!showList">
        <div class="loading-wrapper" *ngIf="isLoading">
          <mat-spinner diameter="40"></mat-spinner>
        </div>

        <div class="empty-wrapper" *ngIf="noItems">
          <h1>No Filters</h1>
        </div>

        <ngx-file-drop class="filter-drop"
                       (onFileDrop)="handleFilterDropped($event)"
                       [useDragEnter]="true"
                       [accept]="'.tqf'"
                       [directory]="false"
                       [showBrowseBtn]="false">
        </ngx-file-drop>

        <mat-list class="filter-list">
          <mat-list-item [class.show-cursor]="showCursor"
                         (click)="handleRowClick(filter)"
                         *cdkVirtualFor="let filter of queryFilters; last as last" [class.query-filter-selected]="filterSelected(filter)">
              <mat-icon mat-list-icon>{{filterIcon(filter)}}</mat-icon>
              <div mat-line class="filter-list-line">
                <div class="metadata">
                  <span class="display-name">{{filter.displayName}}</span>
                  <span class="last-updated">{{filter.lastModified | date: "MMM d, y 'at' h:mm a"}} - {{filter.entity}}</span>
                </div>
                <app-query-filter-actions *ngIf="!hideActions && !isEditing" [queryFilter]="filter"
                                          (actionClicked)="handleAction($event)"></app-query-filter-actions>
              </div>
            <mat-divider *ngIf="!last"></mat-divider>
          </mat-list-item>
        </mat-list>
      </cdk-virtual-scroll-viewport>
    </div>

    <div class="filter-stats" *ngIf="!isEditing">
      <span class="filter-count" *ngIf="(totalFilters|async) !== null">Total Filters: {{totalFilters|async}}</span>
      <mat-spinner diameter="25" *ngIf="(totalFilters|async) === null"></mat-spinner>
    </div>

    <app-query-filter-edit @inOut *ngIf="isEditing as queryFilter" (queryFilterUpdated)="updateFilter($event)" [type]="editorType"
                             [queryFilter]="queryFilter"></app-query-filter-edit>
  </div>
</div>
